export class GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "available",
            "baseName": "available",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reasonCode",
            "baseName": "reasonCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "userMessage",
            "baseName": "userMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogPipelineCapabilitiesResponseEngineAvailabilityInner.attributeTypeMap;
    }
    constructor() {
    }
}
